<div class="container">
  <header>
    <h4>Логи</h4>
  </header>

  <div class="controls">
<!--    <div class="search-box">-->
<!--      <input type="text" [(ngModel)]="searchDataQuery" placeholder="Поиск по логам...">-->
<!--    </div>-->

    <div class="filters">
      <div class="filter-group">
        <label>Пользователи</label>
        <select [(ngModel)]="currentUser">
          <option *ngFor="let user of users" value="{{user}}">{{ user }}</option>
        </select>
      </div>

      <div class="filter-group">
        <label>Действия</label>
        <select [(ngModel)]="currentAction">
          <option value="all">all</option>
          <option value="participants.upload">participants.upload</option>
          <option value="participants.download">participants.download</option>
          <option value="participants.update">participants.update</option>
          <option value="participants.update.tag_not_found">participants.update.tag_not_found</option>
          <option value="participants.assign_start_time">participants.assign_start_time</option>
          <option value="tag_bibs.upload">tag_bibs.upload</option>
          <option value="events.create">events.create</option>
          <option value="events.tag-bib.clear">events.tag-bib.clear</option>
          <option value="events.participants.clear_tag_bib">events.participants.clear_tag_bib</option>
        </select>
      </div>

      <div class="filter-group">
        <label>Дата с</label>
        <input type="datetime-local" class="date-input" [(ngModel)]="beginTimestamp">
      </div>

      <div class="filter-group">
        <label>Дата по</label>
        <input type="datetime-local" class="date-input" [(ngModel)]="endTimestamp">
      </div>

      <button class="apply-btn" (click)="loadLogs()">Применить фильтры</button>
    </div>
  </div>

  <div class="logs-container">
    <table class="logs-table">
      <thead>
      <tr>
        <th>Время</th>
        <th>User</th>
        <th>Action</th>
        <th>Log</th>
        <th>Actions</th>
      </tr>
      </thead>
      <tbody>
      <ng-container
        *ngFor="let log of pageInfo.content"
        style="background-color: #000000; width: 100%">
        <tr>
          <td>{{ log.timestamp }}</td>
          <td><span class="log-level level-info">{{ log.user }}</span></td>
          <td>{{ log.action }}</td>
          <td>
            <div *ngIf="log.action === 'participants.update' && hasBeforeAfter(log)" class="participant-changes">
              <div class="change-summary">
                <h5>
                  <i class="bi bi-person-badge"></i>
                  {{ getParticipantName(log.data.after) }}
                </h5>
                <div class="participant-id">ID: {{ log.data.after.id }}</div>
              </div>

              <div class="changes-grid">
                <div *ngFor="let change of getChanges(log.data)" class="change-item">
                  <div class="change-values">
                    <div class="before-value">
                      <span class="value" [class.empty]="!change.before">
                      {{ getFieldDisplayName(change.field) }}: {{ change.before || 'пусто' }} <i class="bi bi-arrow-right"></i>  {{ change.after || 'пусто' }}
                    </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="log.action === 'events.create'" class="event-creation">
              <h5>
                <i class="bi bi-calendar-plus"></i>
                Создано событие
              </h5>
              <div class="event-details">
                <div class="detail-item" *ngIf="log.data.name">
                  <strong>Название:</strong> {{ log.data.name }}
                </div>
                <div class="detail-item" *ngIf="log.data.date">
                  <strong>Дата:</strong> {{ log.data.date }}
                </div>
                <div class="detail-item" *ngIf="log.data.location">
                  <strong>Место:</strong> {{ log.data.location }}
                </div>
              </div>
            </div>

            <div *ngIf="isUploadAction(log.action)" class="upload-info">
              <h5>
                <i class="bi bi-upload"></i>
                {{ getUploadDisplayName(log.action) }}
              </h5>
              <div class="upload-details">
                <div class="detail-item" *ngIf="log.data.filename">
                  <strong>Файл:</strong> {{ log.data.filename }}
                </div>
                <div class="detail-item" *ngIf="log.data.count">
                  <strong>Количество записей:</strong> {{ log.data.count }}
                </div>
                <div class="detail-item" *ngIf="log.data.size">
                  <strong>Размер:</strong> {{ formatFileSize(log.data.size) }}
                </div>
              </div>
            </div>

            <div *ngIf="!isSpecialCase(log)" class="json-viewer">
              <div class="json-toggle" (click)="toggleJsonExpanded(log.id)">
                <i [class]="isJsonExpanded(log.id) ? 'bi bi-chevron-down' : 'bi bi-chevron-right'"></i>
                Данные ({{ getJsonSize(log.data) }})
              </div>
              <div *ngIf="isJsonExpanded(log.id)" class="json-content">
                <pre>{{ getPrettyJson(log.data) }}</pre>
              </div>
            </div>
          </td>
          <td>
            <button mat-raised-button color="primary" *ngIf="canRevertChanges(log)" (click)="revertChanges(log)">
              <i class="bi bi-arrow-clockwise"></i>
            </button>
          </td>
        </tr>
      </ng-container>
      </tbody>
    </table>
  </div>

  <div class="pagination">
    <button
      class="page-btn"
      [disabled]="!canGoPrev() || isLoading"
      (click)="prevPage()">
      &laquo;
    </button>

    <button
      *ngIf="shouldShowFirstPage()"
      class="page-btn"
      [class.active]="currentPage === 0"
      [disabled]="isLoading"
      (click)="goToPage(0)">
      1
    </button>

    <span *ngIf="shouldShowLeftEllipsis()" class="ellipsis">...</span>

    <button
      *ngFor="let page of visiblePages"
      class="page-btn"
      [class.active]="currentPage === page"
      [disabled]="isLoading"
      (click)="goToPage(page)">
      {{ page + 1 }}
    </button>

    <span *ngIf="shouldShowRightEllipsis()" class="ellipsis">...</span>

    <button
      *ngIf="shouldShowLastPage()"
      class="page-btn"
      [class.active]="currentPage === pageInfo.page.totalPages - 1"
      [disabled]="isLoading"
      (click)="goToPage(pageInfo.page.totalPages - 1)">
      {{ pageInfo.page.totalPages }}
    </button>

    <button
      class="page-btn"
      [disabled]="!canGoNext() || isLoading"
      (click)="nextPage()">
      &raquo;
    </button>
  </div>

  <div class="pagination-info" *ngIf="pageInfo">
  <span>
    Показано {{ pageInfo.content?.length || 0 }} из {{ pageInfo.page.totalElements || 0 }} записей
    (страница {{ currentPage + 1 }} из {{ pageInfo.page.totalPages }})
  </span>
  </div>
</div>

